"use client";

import { trackEvent } from "./track-event";

interface CallbackTrackingProps {
	phoneNumber?: string;
	unitId?: string;
	projectId?: string;
	additionalOptions?: Record<string, unknown>;
}

/**
 * Track callback request events
 * Based on events from i/webapp/components/actionButtons/index.js line 153
 */
export function trackCallback({ phoneNumber, unitId, projectId, additionalOptions = {} }: CallbackTrackingProps = {}) {
	trackEvent({
		google: {
			event: "callback",
			options: {
				event_category: "lead_generation",
				event_label: "callback_request",
				unit_id: unitId,
				project_id: projectId,
				has_phone: !!phoneNumber,
				...additionalOptions,
			},
		},
		facebook: {
			event: "Lead",
			options: {
				content_name: "Callback Request",
				content_category: "lead_generation",
				value: 1,
				currency: "INR",
			},
		},
		matomo: {
			event: "callback_request",
			options: {
				category: "lead",
			},
		},
	});
}

/**
 * Track callback request with unit context
 */
export function trackCallbackForUnit(unitId: string, additionalOptions?: Record<string, unknown>) {
	trackCallback({
		unitId,
		additionalOptions: {
			...additionalOptions,
			event_label: "unit_callback_request",
		},
	});
}

/**
 * Track callback request with project context
 */
export function trackCallbackForProject(projectId: string, additionalOptions?: Record<string, unknown>) {
	trackCallback({
		projectId,
		additionalOptions: {
			...additionalOptions,
			event_label: "project_callback_request",
		},
	});
}
